<!--产业园区-->
<template>
  <div class="park-container">
    <div class="park-content">
      <div class="park-search-menu">
        <p class="park-title">产业园区</p>
        <div class="park-radio-menu">
          <span class="small-title">所属地区</span>
          <div class="radio-menu">
            <el-radio-group v-model="region">
              <el-radio-button :label="''">全国</el-radio-button>
              <el-radio-button v-for="list of provinceList" :label="list.value">{{list.label}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="park-content-info">
        <p class="park-title">为你找到<span class="red-span">{{ tablePage.total }}</span>个园区</p>
        <template v-if="industrialParkInfo.length>0">
          <div class="park-info-list" v-for="park of industrialParkInfo">
            <p class="park-name">{{ park.name }}</p>
            <div class="details-menu">
              <div style="padding-right: 60px">
                <p style="padding-bottom: 10px;">
                  <span class="black-span">省份：</span>
                  <span class="gray-span">{{ park.cityName }}</span>
                </p>
                <p>
                  <span class="black-span">占地面积：</span>
                  <span class="gray-span">{{ park.floorSpace }}</span>
                </p>
              </div>
              <div>
                <p style="padding-bottom: 10px;">
                  <span class="black-span">城市/区：</span>
                  <span class="gray-span">{{ park.areaName }}</span>
                </p>
                <p>
                  <span class="black-span">入驻企业：</span>
                  <span class="gray-span">{{ park.nums }}家</span>
                </p>
              </div>
            </div>

          </div>
          <div style="padding:10px 10px 0px;">
            <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
          </div>
        </template>
        <template v-else>
          <el-empty description="暂无内容"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import page from "@/components/page/pages";
import provinceList from '@/static/provinceList.json'
import {industrialParksList} from '@/api/enterprise_searchApi'

export default {
  name: "industrialPark",
  components: {page},
  data() {
    return {
      region: '',
      industrialParkInfo: [],
      provinceList: provinceList,
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  watch: {
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getIndustrialParkInfo();
      }
    },
  },
  methods: {
    /*获取产业园区*/
    getIndustrialParkInfo() {
      industrialParksList({
        cityCode: this.region || 0,
        keyword: '',
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = parseInt(res.content.total);
          this.industrialParkInfo = res.content.rows;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getIndustrialParkInfo();
    },
  },
  mounted() {
    this.getIndustrialParkInfo();
  },
  beforeMount() {

  }
}
</script>
<style scoped>
.park-container >>> .park-content .park-search-menu .park-radio-menu .el-radio-button__inner {
  background: #FFF;
  border: none;
  font-weight: 500;
  color: #333333;
  padding: 10px 10px;
  font-size: 14px;
  border-radius: 6px;
}

.park-container >>> .park-content .park-search-menu .park-radio-menu .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFFFFF;
  background-color: #1637FF;
  border: none;
  -webkit-box-shadow: 0 0 0 0 #333333;
  box-shadow: 0 0 0 0 #333333;
}
</style>
<style scoped lang="scss">
.park-container {
  .park-content {
    .park-search-menu {
      .park-title {
        padding: 20px;
        margin-block-start: 0px;
        margin-block-end: 0px;
        font-size: 14px;
        font-family: "SourceHanSansCN";
        color: #333333;
        border-bottom: 1px solid #EBEDF6;
      }

      .park-radio-menu {
        display: flex;
        justify-content: left;
        padding: 20px;

        .small-title {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #999999;
          display: inline-block;
          padding-right: 40px;
        }

        .radio-menu {
          width: 89%;
        }
      }
    }
    .park-content-info {
      .park-title {
        font-size: 14px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        display: flex;
        margin-block-end: 0px;
        margin-block-start: 0px;
        border-top: 20px solid #F5F5F5;
        padding: 20px;
        border-bottom: 1px solid #F5F5F5;

        .red-span {
          color: #fe273b;
        }
      }
      .park-info-list {
        padding: 20px;
        border-bottom: 1px solid #E7E9F5;
        .park-name {
          font-size: 18px;
          font-family: 'SourceHanSansCN';
          color: #333333;
          padding-bottom: 20px;
          margin-block-end: 0px;
          margin-block-start: 0px;
          font-weight: 600;
        }
        .details-menu{
          display: flex;
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>